import { isPlatformBrowser } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Inject,
    PLATFORM_ID,
} from "@angular/core";
import Hotjar from "@hotjar/browser";
import { environment } from "../environments/environment";
import { MainComponent } from "./modules/main/components/main/main.component";

@Component({
    selector: "ls-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MainComponent,
    ],
})
export class AppComponent implements AfterViewInit {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public ngAfterViewInit(): void {
        if (environment.domain === "PROD" && isPlatformBrowser(this.platformId)) {
            const siteId = 6490714;
            const hotjarVersion = 6;
            Hotjar.init(siteId, hotjarVersion);
            console.warn("hj enabled");
        }
    }

}
